const BDataTable = {
    namespaced: true,
    state: {
        items: [],
        screenConfiguration: {
            current: {
                id: false,
            },
            route: null,
            data: [],
            filterToLoad: null,
        },
        filters: {},
        initialFilters: {},
        fields: ['*'],
        columns: [],
        hiddenColumns: [],
        sort: [],
        meta: null,
        tab: null,
    },
    mutations: {
        SET_TAB(state, tab) {
            state.tab = tab;
        },
        RESET_SCREEN_CONFIGURATION(state) {
            _.set(state, 'screenConfiguration.filterToLoad', false);
            _.set(state, 'screenConfiguration.current', {
                id: false,
            });
        },
        SET_ITEMS(state, items) {
            state.items = items;
        },
        SET_FILTERS(state, filters) {
            state.filters = filters;
        },
        SET_INITIALS_FILTERS(state, initialFilters) {
            state.initialFilters = initialFilters;
        },
        SET_FIELDS(state, fields) {
            state.fields = fields;
        },
        SET_COLUMNS(state, columns) {
            state.columns = columns;
        },
        SET_HIDDEN_COLUMNS(state, hiddenColumns) {
            state.hiddenColumns = hiddenColumns;
        },
        SET_SORT(state, sort) {
            state.sort = sort;
        },
        SET_META(state, meta) {
            state.meta = meta;
        },
        SET_SCREEN_CONFIGURATION(state, data) {
            _.set(state, 'screenConfiguration.data', data);
        },
        SET_SCREEN_CONFIGURATION_ROUTE(state, route) {
            _.set(state, 'screenConfiguration.route', route);
        },
        SET_SCREEN_CONFIGURATION_CURRENT(state, current) {
            _.set(state, 'screenConfiguration.current', current);
        },
        SET_SCREEN_CONFIGURATION_FILTER_TO_LOAD(state, id) {
            _.set(state, 'screenConfiguration.filterToLoad', id);
        },
    },
    actions: {
        changeTab({ commit }, tab) {
            commit('SET_TAB', tab);
        },
        setItems({ commit }, items) {
            commit('SET_ITEMS', items);
        },
        setMeta({ commit }, meta) {
            commit('SET_META', _.clone(meta));
        },
        setFields({ commit }, fields) {
            commit('SET_FIELDS', fields);
        },
        setColumns({ commit }, columns) {
            commit('SET_COLUMNS', columns);
        },
        setHiddenColumns({ commit }, hiddenColumns) {
            commit('SET_HIDDEN_COLUMNS', hiddenColumns);
        },
        setInitialsFilters({ commit }, initialFilters) {
            commit('SET_INITIALS_FILTERS', _.clone(initialFilters));
        },
        setFilters({ commit }, filters) {
            commit('SET_FILTERS', _.clone(filters));
        },
        setSort({ commit }, sort) {
            commit('SET_SORT', _.clone(sort));
        },
        setCurrentScreenConfiguration({ commit }, current) {
            commit('SET_SCREEN_CONFIGURATION_CURRENT', current);
            commit('SET_SCREEN_CONFIGURATION_FILTER_TO_LOAD', current.id);
        },
        setCurrentScreenConfigurationId({ commit }, id) {
            commit('SET_SCREEN_CONFIGURATION_FILTER_TO_LOAD', id);
        },
        resetScreenConfiguration({ commit }) {
            commit('RESET_SCREEN_CONFIGURATION');
        },
        loadScreenConfiguration({ commit }, routes) {
            commit('SET_SCREEN_CONFIGURATION_ROUTE', routes);
            axios
                .get(route('api.v1.filters.index'), {
                    params: {
                        route: routes,
                    },
                })
                .then((response) => {
                    const data = Object.values(response.data.data);
                    commit('SET_SCREEN_CONFIGURATION', data);
                });
        },
        saveScreenConfiguration({ dispatch }, data) {
            const currentRoute = data.route || false;
            return axios.post(route('api.v1.filters.store'), data).then(() => {
                dispatch('loadScreenConfiguration', currentRoute);
            });
        },
        loadPharmacySitesOptions({ commit }) {
            axios
                .get(
                    route('api.v1.pharmacy-sites.options', {
                        params: {
                            sort: 'name',
                        },
                    })
                )
                .then((response) => {
                    const data = response.data.data;
                    commit('SET_PHARMACY_SITES_OPTIONS', data);
                });
        },
        updateProperty({ commit }, data) {
            if (data.property.includes('ip') && data.value.length > 3) {
                return;
            }

            commit('SET_ASTM_DEVICE_PROPERTY', data);
        },
        loadAstmDevice({ commit, dispatch }, data) {
            commit('SET_ASTM_DEVICE', data);
            dispatch('addIpAddress');
        },
    },
};

export default BDataTable;
